// Customer-name display + sort helpers.
//
// Lifted from the inline implementation that lived in RentalForm.js so the
// "last name first" display and last-name sort behave identically everywhere
// a customer list/dropdown is rendered (rentals, payments, customers list).

// "Russ Coates" -> "Coates, Russ" (last name first). Multi-word first names
// are kept; single-token names pass through unchanged.
export const toLastFirst = (name) => {
  const p = String(name || '').trim().split(/\s+/);
  if (p.length < 2) return name || '';
  return `${p[p.length - 1]}, ${p.slice(0, -1).join(' ')}`;
};

// Sort key: last name, then first name (lower-cased for case-insensitive
// compare). "Russ Coates" -> "coates russ".
export const lastNameKey = (name) => {
  const p = String(name || '').trim().split(/\s+/);
  const last = p.length > 1 ? p[p.length - 1] : (p[0] || '');
  return `${last} ${p.slice(0, -1).join(' ')}`.toLowerCase();
};

// Comparator: sort by last name then first name, case-insensitive, using
// locale-aware compare. Accepts customer-ish objects ({ full_name }) or
// raw name strings.
export const byLastName = (a, b) => {
  const nameOf = (x) =>
    x && typeof x === 'object' ? (x.full_name || x.name || '') : x;
  return lastNameKey(nameOf(a)).localeCompare(
    lastNameKey(nameOf(b)),
    undefined,
    { sensitivity: 'base' },
  );
};
